import React from 'react';

import BaseComponentProperty from "../index";

export default class Image extends BaseComponentProperty {
    renderOwnProperties() {
        return (
            <div>
                <div>
                    <label htmlFor="src">Link</label>
                    <textarea
                        id="src"
                        className='form-control'
                        value={this.props.component.data.src ? this.props.component.data.src : ''}
                        onChange={event => {
                            let data = this.props.component.data;
                            if (event.target.value) {
                                data.src = event.target.value;
                            } else {
                                delete data.src;
                            }
                            this.props.onChange('data', data);
                        }}
                    />
                </div>
                <div>
                    <label htmlFor="caption">Caption</label>
                    <textarea
                        id="caption"
                        className='form-control'
                        value={this.props.component.data.caption ? this.props.component.data.caption : ''}
                        onChange={event => {
                            let data = this.props.component.data;
                            if (event.target.value) {
                                data.caption = event.target.value;
                            } else {
                                delete data.caption;
                            }
                            this.props.onChange('data', data);
                        }}
                    />
                </div>
                <div>
                    <label htmlFor="caption">Alt</label>
                    <textarea
                        id="alt"
                        className='form-control'
                        value={this.props.component.data.image_alt ? this.props.component.data.image_alt : ''}
                        onChange={event => {
                            let data = this.props.component.data;
                            if (event.target.value) {
                                data.image_alt = event.target.value;
                            } else {
                                delete data.image_alt;
                            }
                            this.props.onChange('data', data);
                        }}
                    />
                </div>
            </div>
        );
    }
}
